import { firebase } from '@firebase/app';
import '@firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyB7wNxM7l3JYThOBw8AN7C5od0KBraaefk',
  authDomain: 'gsuitetrickstar.firebaseapp.com',
  projectId: 'gsuitetrickstar',
  storageBucket: 'gsuitetrickstar.appspot.com',
  messagingSenderId: '1025913966649',
  appId: '1:1025913966649:web:068ba65cdce598425e7de8',
});

export const db = firebaseApp.firestore();
